<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-xs font-medium text-gray-900 tabular-nums">
      <a role="button" href="#" @click.prevent="showContactRequest">{{
        contactRequest.fullName
      }}</a>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">{{ assigneeFullName }}</td>
    <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
      <RouterLink v-if="projectRoute" :to="projectRoute"> {{ projectName }} </RouterLink
      ><span v-else>{{ projectName }}</span>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
      {{ pipelineStageName }}
    </td>
    <td class="px-4 py-4 text-xs text-gray-500 text-right whitespace-nowrap">
      {{ dateCreated }}
    </td>
  </tr>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    assigneeFullName() {
      if (!this.contactRequest.userId) {
        return this.$t('global.unassigned');
      }

      return this.contactRequest?.user?.fullName || this.$t('not_available');
    },
    projectName() {
      return this.contactRequest?.project?.name || 'Not in a project';
    },
    pipelineStageName() {
      return this.contactRequest?.pipelineStage?.name || 'Not in a pipeline';
    },
    projectRoute() {
      if (!this.contactRequest.projectId || !this.contactRequest.accountId) {
        return null;
      }
      return {
        name: 'accounts.projects.project',
        params: {
          accountId: this.contactRequest.accountId,
          projectId: this.contactRequest.projectId,
        },
      };
    },
    createdAt() {
      return moment.utc(this.contactRequest.createdAt).local();
    },
    dateCreated() {
      return this.createdAt.format('DD/MM/YYYY HH:mm');
    },
  },
  methods: {
    showContactRequest() {
      this.$modal.show({
        component: () => import('Components/ContactRequests/ContactRequestModal.vue'),
        props: {
          contactRequestId: this.contactRequest.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
